//src/components/shared/OperationalClientRequired.tsx
import { Building2 } from "lucide-react";

import { Card } from "@/components/ui/card";

export function OperationalClientRequired() {
  return (
    <Card className="border-dashed p-8 text-center">
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-muted">
        <Building2 className="h-6 w-6 text-muted-foreground" />
      </div>

      <h2 className="mt-4 text-lg font-semibold text-foreground">
        Selecione um cliente para continuar
      </h2>

      <p className="mx-auto mt-2 max-w-xl text-sm text-muted-foreground">
        Esta funcionalidade depende do cliente operacional selecionado. Use o seletor de cliente no topo da plataforma para carregar, criar ou alterar dados deste módulo.
      </p>
    </Card>
  );
}
